import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {FormsModule} from '@angular/forms';

import {MatIcon} from '@angular/material/icon';

@Component({
    selector: 'app-modular-mechanical-connections-section',
    templateUrl: './modular-mechanical-connections-section.component.html',
    styleUrls: ['./modular-mechanical-connections-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class ModularMechanicalConnectionsSectionComponent implements OnChanges {

  readonly selections = input.required<GuruEntity[]>();
  readonly invalidEntityNames = input.required<string[]>();
  readonly handArrangementImagePath = input.required<string>();
  readonly pipeDetailImagePath = input.required<string>();
  readonly selectionChanged = output<GuruEntity>();
  returnLocationSelection!: GuruEntity;
  frontSupplySelection!: GuruEntity;
  leftSupplySelection!: GuruEntity;
  riserConnectionSelection!: GuruEntity;
  riserFlowSelection!: GuruEntity;
  returnAirSelection!: GuruEntity;
  supplyAirSelection!: GuruEntity;
  opposedBladeDamperSelection!: GuruEntity;
  outsideAirSelection!: GuruEntity;
  outsideAirLocationSelection!: GuruEntity;
  paintOptionsSelection!: GuruEntity;
  topSupplySelection!: GuruEntity;
  rightSupplySelection!: GuruEntity;
  collapsed: boolean = false;
  canExpand: boolean = true;
  private readonly selectionNames: string[] = ['USReturnLocation', 'USSupplyFront', 'USSupplyLeft', 'USRiserConn', 'USRiserFlow', 'USReturnAirOptions', 'USSupplyType', 'USSupplyTypeOBD', 'USOutsideAir', 'USOutsideAirLocation', 'USPaintOptions', 'USSupplyTop', 'USSupplyRight'];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filteredSelections: GuruEntity[] = this.selections().filter(selection => this.selectionNames.indexOf(selection.Name) >= 0);
    if (filteredSelections.length === 0) {
      this.collapsed = true;
      this.canExpand = false;
    } else {
      this.returnLocationSelection = this.getSelectionWithName(this.selectionNames[0], filteredSelections);
      this.frontSupplySelection = this.getSelectionWithName(this.selectionNames[1], filteredSelections);
      this.leftSupplySelection = this.getSelectionWithName(this.selectionNames[2], filteredSelections);
      this.riserConnectionSelection = this.getSelectionWithName(this.selectionNames[3], filteredSelections);
      this.riserFlowSelection = this.getSelectionWithName(this.selectionNames[4], filteredSelections);
      this.returnAirSelection = this.getSelectionWithName(this.selectionNames[5], filteredSelections);
      this.supplyAirSelection = this.getSelectionWithName(this.selectionNames[6], filteredSelections);
      this.opposedBladeDamperSelection = this.getSelectionWithName(this.selectionNames[7], filteredSelections);
      this.outsideAirSelection = this.getSelectionWithName(this.selectionNames[8], filteredSelections);
      this.outsideAirLocationSelection = this.getSelectionWithName(this.selectionNames[9], filteredSelections);
      this.paintOptionsSelection = this.getSelectionWithName(this.selectionNames[10], filteredSelections);
      this.topSupplySelection = this.getSelectionWithName(this.selectionNames[11], filteredSelections);
      this.rightSupplySelection = this.getSelectionWithName(this.selectionNames[12], filteredSelections);
    }
  }

  private getSelectionWithName(name: string, selections: GuruEntity[]): GuruEntity {
    for (const selection of selections) {
      if (selection.Name === name) {
        return JSON.parse(JSON.stringify(selection));
      }
    }
    return undefined!;
  }

  selectedValueChanged(selectionName: string, value: string): void {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = selectionName;
    entity.Value = value;
    this.selectionChanged.emit(entity);
  }

  getExpansionIcon(): string {
    return this.collapsed ? 'arrow_drop_down' : 'arrow_drop_up';
  }

  toggleExpansion(): void {
    if (this.canExpand) {
      this.collapsed = !this.collapsed;
    }
  }

  isInvalidSelection(selectionName: string): boolean {
    return this.invalidEntityNames().indexOf(selectionName) >= 0;
  }

}
